<template>
<div>
<transition name="fade">
 <landing-page-familia />
</transition>
 <!-- <edad-modal v-if="showModal" @close="chkEdad" /> -->
</div>
  
</template>

<script>
import  edadModal  from '@/components/edad.vue'
import  landingPageFamilia  from '@/components/familia.vue'

export default {
  components: {
    edadModal,
    landingPageFamilia
  },
  name: 'home',
  data() {
    return {
      showModal: true
    }
  },
  methods: {
    chkEdad() {
      this.showModal = false
    }
  },
}
</script>
<style >

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

